/* eslint-disable id-blacklist, no-restricted-imports */
import { css } from '@emotion/core';
import { rgba } from 'polished';
import { variables as vars } from '@domain-group/fe-brary';
var colour = vars.colour,
  font = vars.font;
export var mediaStats = /*#__PURE__*/css("position:absolute;bottom:5px;right:0;background-color:", rgba(colour.black, 0.3), ";color:", colour.white, ";margin-right:8px;border-radius:2px;");
export var mediaItem = {
  name: "k0sew7",
  styles: "height:24px;display:inline-block;vertical-align:top;"
};
export var value = /*#__PURE__*/css("font-size:", font.xsmallFontSize, ";line-height:22px;vertical-align:top;margin-left:0;margin-right:4px;");
export var icon = {
  name: "vu1g14",
  styles: "position:relative;top:-2px;margin:0 4px;width:18px;height:18px;"
};